/**
 * Cette classe fait office de classe abstraite
 */
export default class BaseDto {
  /**
   * Construction de la classe parent à partir d'un flux Json
   * @param inoJson flux parsé
   */
  constructor(inoJson = {}) {
    this.buildModel(inoJson, this.schema);
  }

  /**
   * Retourne la structure de la classe -> attributs
   */
  get schema() {  // eslint-disable-line
    return {
      id: undefined,
      version: undefined,
      userId: undefined,

      createdAt: undefined,
      updatedAt: undefined,
    };
  }

  /**
   * Alimente les attributs à partir du flux json
   * @param inoJson
   * @param inoSchema
   */
  buildModel(inoJson = {}, inoSchema = {}) {
    Object.keys(inoSchema).forEach((insClassAtt) => {
      const sJsonAtt = typeof inoJson[insClassAtt];
      if (['number', 'boolean', 'string', 'object'].includes(sJsonAtt) && ![undefined, null].includes(inoJson[insClassAtt])) {
        this[insClassAtt] = inoJson[insClassAtt];
      } else {
        this[insClassAtt] = inoSchema[insClassAtt];
      }
    });
    this.buildCustom();
  }

  /**
   * Convertir la partie spécifique comme les dates en objet de type Date
   * Doit être surchargée par la classe parente
   * @return {BaseDto}
   */
  buildCustom() { // eslint-disable-line
    if (this.createdAt !== undefined && !(this.createdAt instanceof (Date))) {
      this.createdAt = new Date(this.createdAt);
    }
    if (this.updatedAt !== undefined && !(this.updatedAt instanceof (Date))) {
      this.updatedAt = new Date(this.updatedAt);
    }
    return this;
  }

  /**
   * Nettoye tous les attributs
   * @return {BaseDto}
   */
  baseClear() {
    Object.keys(this.schema).forEach((insAtt) => {
      const sType = this[insAtt];

      if (sType !== undefined) {
        delete this[insAtt];
      }
      if (Array.isArray(this[insAtt]) && !this[insAtt].length) {
        delete this[insAtt];
      }
      if (['', undefined].includes(this[insAtt])) {
        delete this[insAtt];
      }
    });
    return this;
  }

  /**
   * Prépare la création de l'objet
   * @return {BaseDto}
   */
  prepareCreate() {
    this.baseClear();
    return this;
  }

  /**
   * Prépare la mise à jour de l'objet
   * @return {BaseDto}
   */
  prepareUpdate() {
    this.baseClear();
    return this;
  }

  /**
   * Construit une liste d'objet à partir du flux json
   * @param inoMap Flux json parser
   * @param callback fonction factory pour obtenir une nouvelle instance de l'objet
   * @return {Array}
   */
  static jsonToList(inoMap, callback) {
    const listFound = [];
    if (inoMap && Array.isArray(inoMap) && inoMap.length > 0) {
      inoMap.forEach((inoValue) => {
        listFound.push(callback(inoValue));
      });
    }
    return listFound;
  }
}
